import React from 'react';
import {
  Button,
  Flashy,
  Gutter,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
  ParagraphHeader,
} from '@axiom/ui';
import type { TopTask } from '@axiom/validation';
import { TopTaskTypes } from '@axiom/validation';

export type WorkspaceTopTasksIssueModalProps = {
  name?: string;
  topTask: TopTask;
  onClose: () => void;
};

export const WorkspaceTopTasksIssueModal = ({
  name = 'TOP_TASK_CANDIDATE_ISSUE_MODAL',
  topTask,
  onClose,
}: WorkspaceTopTasksIssueModalProps) => {
  const displayCandidateIssue = () => {
    if (
      topTask.topTaskType ===
      TopTaskTypes.CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS
    ) {
      return 'State/Province/County';
    }

    if (
      topTask.topTaskType === TopTaskTypes.CANDIDATE_ISSUE_MISSING_FOCUS_AREA
    ) {
      return 'LT - Practice Area / Focus';
    }

    return topTask.topTaskType ===
      TopTaskTypes.CANDIDATE_ISSUE_MISSING_BUSINESS_TITLE
      ? 'LT - Legal Role'
      : 'N/A';
  };
  return (
    <Modal name={name} size="confirm">
      <ModalHeader
        name="TOP_TASK_CANDIDATE_ISSUE_MODAL_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Update Data in Greenhouse
      </ModalHeader>
      <ModalSection>
        <Gutter bottom="16px">
          <Paragraph>
            Missing information in Greenhouse is preventing this Talent from
            being priced and submitted.
          </Paragraph>
        </Gutter>
        <Gutter bottom="16px">
          <ParagraphHeader>Talent</ParagraphHeader>
          <Paragraph name="TOP_TASK_CANDIDATE_ISSUE_CANDIDATE_DISPLAY_NAME">
            {topTask.candidateCalculatedDisplayName}
          </Paragraph>
        </Gutter>
        <ParagraphHeader>Greenhouse Field(s)</ParagraphHeader>
        <Paragraph name="TOP_TASK_CANDIDATE_ISSUE_FIELD_NAME">
          {displayCandidateIssue()}
        </Paragraph>
        {topTask.topTaskType ===
          TopTaskTypes.CANDIDATE_ISSUE_MISSING_ADDRESS_FIELDS && (
          <Paragraph name="TOP_TASK_CANDIDATE_ISSUE_FIELD_NAME_ADDITIONAL">
            Country
          </Paragraph>
        )}
        {topTask.topTaskType ===
          TopTaskTypes.CANDIDATE_ISSUE_MISSING_FOCUS_AREA && (
          <Gutter name="TOP_TASK_CANDIDATE_ISSUE_FIELD_NAME_NOTE" top="16px">
            <Paragraph>
              <Flashy italic>
                Note: talent must be assigned to a Focus Area, not a Practice
                Area in this field
              </Flashy>
            </Paragraph>
          </Gutter>
        )}
      </ModalSection>
      <ModalFooter>
        <Button
          name="TOP_TASK_CANDIDATE_ISSUE_MODAL_CLOSE_BUTTON"
          onClick={() => {
            onClose();
          }}
        >
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
};
